<template>
    <div id="popup-share" class="popup-wrap" role="dialog" :class="onModalClass">
        <div class="popup-header">
            <h1>공유하기</h1>
            <button class="close-btn" aria-label="공유하기 닫기" @click="close"></button>
        </div>
        <div class="popup-conts">
            <div class="btn-container-rounded">
                <button type="button" class="btn-line type-dark btn-kakao" @click="onKakaoShare">카카오톡 공유</button>
            </div>
            <div class="ern-text">
                <input class="ern-copy-url" type="text" readonly="" title="공유하기 URL" :value="rootStore.shareInfo.url || ''" />
                <div class="tooltip-popup">
                    <button type="button" class="btn-question" @click="toggleTooltip">
                        <span class="blind">정보열기</span>
                    </button>
                    <div class="tooltip-wrap" :class="{ inActive: !isTooltipVisible }">
                        <div class="content-box">
                            URL을 드래그해서 복사하세요<button type="button" class="btn-close" @click="closeTooltip">
                                <span class="blind">툴팁 닫기</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue';
    import { useRootStore } from '@/stores/modules';

    const emit = defineEmits(['close']);
    const rootStore = useRootStore();

    const onModalClass = ref('popup-hidden');
    const isTooltipVisible = ref(false);

    const open = () => {
        onModalClass.value = 'slideUp';
    };

    const close = () => {
        onModalClass.value = 'slideDown';
        setTimeout(() => {
            onModalClass.value = 'popup-hidden';
            emit('close');
        }, 200);
    };

    const toggleTooltip = () => {
        isTooltipVisible.value = !isTooltipVisible.value;
    };

    const closeTooltip = () => {
        isTooltipVisible.value = false;
    };

    const onKakaoShare = () => {
        // Kakao SDK가 로드되었는지 확인
        if (!window.Kakao) {
            alert('카카오톡 SDK가 로드되지 않았습니다.');
            return;
        }

        // Kakao 초기화 확인 (App.vue에서 수행됨)
        if (!window.Kakao.isInitialized()) {
            alert('카카오톡 SDK가 초기화되지 않았습니다. 관리자에게 문의하세요.');
            return;
        }

        // 스토어에서 공유 정보 가져오기
        const { title, description, image, url, id } = rootStore.shareInfo || {};

        // 앱 실행 파라미터 구성 (이벤트 전용: eventId=3 등)
        const executionParams = id ? `eventId=${id}` : '';

        // 공유하기 실행
        try {
            window.Kakao.Share.sendDefault({
                objectType: 'feed',
                content: {
                    title: title || '스타필드 마켓 이벤트',
                    description: description || '스타필드 마켓의 새로운 이벤트를 확인해보세요!',
                    imageUrl: image,
                    link: {
                        mobileWebUrl: url,
                        webUrl: url,
                    },
                    imageWidth: 800,
                    imageHeight: 400,
                },
                buttons: [
                    {
                        title: '이벤트 상세 보러가기',
                        link: {
                            mobileWebUrl: url,
                            webUrl: url,
                            androidExecutionParams: executionParams,
                            iosExecutionParams: executionParams,
                        },
                    },
                ],
            });
        } catch (e) {
            console.error('Kakao Share Failed:', e);
            alert('카카오톡 공유 중 오류가 발생했습니다.');
        }
    };

    defineExpose({ open });
</script>

<style scoped>
    /* Ensure popup styles are applied if scoped, or rely on global CSS */
    /* Based on markup, styles seem global (.popup-wrap), but adding scoped for specific tweaks if needed */
</style>
